
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'
export default defineComponent({
  setup() {
    return {
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  data() {
    return {
      users: []
    }
  },
  computed: {
    projectUserCount(): number {
      return this.users?.length
    }
  },
  methods: {
    onClick() {
      window.open('/assets/Ubiant - Contrat de garantie de service et maintenance - V 28-04-2023.pdf', '_blank')
    },
    async refreshProjectUsers() {
      try {
        const currentBuildingId = await this.getCurrentBuildingId()
        if (currentBuildingId) {
          const { data: currentBuilding } = await hemisphereService.getBuilding(currentBuildingId)
          if (currentBuilding.project_id) {
            const resp = await hemisphereService.getUsersOfBuildingsInGroupEntity(currentBuilding.project_id)
            this.users = resp.data
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  async mounted() {
    await this.refreshProjectUsers()
  }
})
